import React, { useEffect, useState } from 'react'
import dashOne from '../Images/dashone.svg'
import dashTwo from '../Images/ayurveda.jpg'
import feeImage from '../Images/custom-13.svg'
import axios from 'axios'

// firebase
import {db} from '../firebase';
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { collection, doc, getDoc, getDocs, query, where } from "firebase/firestore"

import { useLocation } from '../LocationContext';  // Ensure this context is properly defined

function DashInComp() {

  //states
  const [loggedInUser, setLoggedInUser] = useState("");
  const [studentsNeedingAttention, setStudentsNeedingAttention] = useState(0);
  const [assignmentsPendingReview, setAssignmentsPendingReview] = useState(0);
  const [now, setNow] = useState(() => new Date());

  const { location, currency } = useLocation();  // Ensure that location and currency are provided by the context



  const auth = getAuth();

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (!user) return

      const uid = user.uid

      try {
        const employeeQuery = query(collection(db, "Employees"), where("docId", "==", uid));
        const employeeSnapshot = await getDocs(employeeQuery)
        employeeSnapshot.forEach((employeeDoc)=>{
          const username = employeeDoc.data().employeeName;
          setLoggedInUser(username);
        })

        const classSnapshot = await getDocs(query(collection(db, 'allclasses'), where('instructor', '==', uid)))
        const classIds = classSnapshot.docs
          .map((classDoc) => classDoc.data()?.roomID || classDoc.id)
          .filter(Boolean)

        const membershipSnapshots = await Promise.all(
          classIds.map((classId) => getDocs(query(collection(db, 'StudentsInClass'), where('classID', '==', classId))))
        )

        const studentIds = Array.from(new Set(
          membershipSnapshots
            .flatMap((snapshot) => snapshot.docs.map((studentDoc) => {
              const student = studentDoc.data() || {}
              return student.studentID || student.userId || ''
            }))
            .filter(Boolean)
        ))

        const fireflySnapshots = await Promise.all(
          studentIds.map(async (studentId) => {
            try {
              const learnerProfile = await getDoc(doc(db, 'plm', studentId))
              return { studentId, profile: learnerProfile.exists() ? learnerProfile.data() : null }
            } catch (error) {
              return { studentId, profile: null }
            }
          })
        )

        const attentionCount = fireflySnapshots.filter(({ profile }) => {
          if (!profile) return false
          const struggles = Array.isArray(profile.struggles) ? profile.struggles.length : 0
          const misconceptions = Array.isArray(profile.misconceptions) ? profile.misconceptions.length : 0
          const diagnoses = Array.isArray(profile.diagnoses) ? profile.diagnoses.length : 0
          return struggles > 0 || misconceptions > 0 || diagnoses > 0
        }).length

        setStudentsNeedingAttention(attentionCount)

        const assignmentsSnapshot = await getDocs(
          query(collection(db, 'courseAssignments'), where('instructorId', '==', uid))
        )

        const assignmentIds = assignmentsSnapshot.docs.map((assignmentDoc) => assignmentDoc.id).filter(Boolean)
        let pendingReviewCount = 0

        if (assignmentIds.length > 0) {
          const submissionSnapshots = await Promise.all(
            Array.from({ length: Math.ceil(assignmentIds.length / 10) }, (_, index) => (
              getDocs(query(
                collection(db, 'assignmentSubmissions'),
                where('assignmentId', 'in', assignmentIds.slice(index * 10, index * 10 + 10))
              ))
            ))
          )

          pendingReviewCount = submissionSnapshots
            .flatMap((snapshot) => snapshot.docs.map((submissionDoc) => submissionDoc.data() || {}))
            .filter((submission) => {
              const status = String(submission.reviewStatus || submission.status || 'submitted').toLowerCase()
              return !status.includes('review')
            }).length
        }

        setAssignmentsPendingReview(pendingReviewCount)
      } catch (error) {
        console.error('Error loading instructor dashboard stats:', error)
      }
    })

    return () => unsubscribe()
  }, [auth])

  //date functions
  const todaysDate = now;
  const todayDay = todaysDate.getDate();
  const todayDayOfWeek = todaysDate.getDay();
  const todayMonth = todaysDate.getMonth();
  const todayYear = todaysDate.getFullYear();

  const weekArray = ["Sunday","Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
  const monthArray = ["January","February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

  const todayDayState = todayDay;
  const todayWeekState = weekArray[todayDayOfWeek];
  const localTimezone = location?.timezone || Intl.DateTimeFormat().resolvedOptions().timeZone || 'Africa/Nairobi';
  const todayMonthState = monthArray[todayMonth];
  const todayYearState = todayYear;
  const formattedTime = todaysDate.toLocaleTimeString([], {
    hour: 'numeric',
    minute: '2-digit',
    timeZone: localTimezone
  });
  const nairobiTime = todaysDate.toLocaleTimeString('en-KE', {
    hour: 'numeric',
    minute: '2-digit',
    timeZone: 'Africa/Nairobi'
  });
  const nairobiDate = todaysDate.toLocaleDateString('en-KE', {
    weekday: 'long',
    day: 'numeric',
    month: 'long',
    timeZone: 'Africa/Nairobi'
  });
  const localDateLabel = todaysDate.toLocaleDateString([], {
    weekday: 'long',
    day: 'numeric',
    month: 'long',
    timeZone: localTimezone
  });
  const localDayNumber = todaysDate.toLocaleDateString([], {
    day: 'numeric',
    timeZone: localTimezone
  });
  const localTimezoneLabel = localTimezone.replace('_', ' ');
  const localPlaceLabel = [
    location?.city,
    location?.region,
    currency?.countryName || location?.country
  ].filter(Boolean).join(', ');

  const [weatherImg, setWeatherImg] = useState();
  const [weatherText, setWeatherText] = useState();
  const [thecurrentWeatherTemp, setcurrentWeatherTemp] = useState();

  useEffect(() => {
    const clock = window.setInterval(() => {
      setNow(new Date());
    }, 60000);

    return () => window.clearInterval(clock);
  }, []);
  
  useEffect(() => {
      const myWeatherApi = `https://api.weatherapi.com/v1/current.json?key=ecd0603cbba44123b30161245240206&q=Nairobi&aqi=no`;

      axios
        .get(myWeatherApi)
        .then((res) => {
          console.log(res.data);
          let currentWeatherImg = res.data.current.condition.icon;
          setWeatherImg(currentWeatherImg);
          let currentWeatherText = res.data.current.condition.text;
          setWeatherText(currentWeatherText);
          let currentWeatherTemp = res.data.current.feelslike_c;
          setcurrentWeatherTemp(currentWeatherTemp);
          
        })
        .catch((err) => {
          console.error(err);
        });
  }, []);

  //dates end
  



  return (
<div className='dashComp'>
  <div className='dashFlex1'>
      <div className='dash1'>
          <div className='dash1Cont'>
              <h4>Welcome</h4>
              <p>{loggedInUser || 'Instructor'}</p>
          </div>
          <img src={dashOne} alt="" />
      </div>

      <div className='dash2'>
          <div className='cliRight3'>
            <div className='cliRight3Block'>
              <span className='cliRight3Label'>Ubunifu HQ</span>
              <p>{nairobiDate}</p>
              <h2>{nairobiTime}</h2>
              <p>Nairobi, Kenya</p>
            </div>

            {weatherImg ? <img src={weatherImg} alt={weatherText || 'Weather'} className='cloidIcoClient' /> : null}

            <div className='cliRight3Block cliRight3WeatherBlock'>
              <h2>{thecurrentWeatherTemp ? `${thecurrentWeatherTemp}°` : '--'}</h2>
              <p>{weatherText || 'Weather loading'}</p>
              <small>Live from Nairobi campus</small>
            </div>
          </div>

          <div className='dChild1'>
              <span className='dDashboardCardLabel'>Support Queue</span>
              <h5>{studentsNeedingAttention}</h5>
              <p>Students Needing Attention</p>
              <small>Firefly learners who may need a closer follow-up.</small>
          </div>

          <div className='dChild2 d-flex'>
              <div className='the2child2'>
                  <span className='dDashboardCardLabel'>Review Queue</span>
                  <p>Assignments Pending Review</p>
                  <h6>{assignmentsPendingReview}</h6>
                  <small>Fresh submissions that are waiting for your feedback.</small>
              </div>
              <div>
                  <img src={feeImage} alt="" />
              </div>                
          </div>
      </div>
  </div>

  <div className='dashFlex1'>
      <div className='dash3'>
          <hr />
          <h6>Shape Future Code Chefs</h6>
          <p>Your journey to mentoring and shaping future code chefs starts here</p>
          <img src={dashTwo} alt="" />
      </div>

      <div className='dash4'>

      </div>

      <div className='dash5'>
          <div className='dashDateCont'>
              <h2>{localDayNumber}</h2>
          </div>
          <span className='dash5Label'>Your Local Time</span>
          <h6>{formattedTime}</h6>
          <p>{localDateLabel}</p>
          <small>{localPlaceLabel || 'Your location'} • {localTimezoneLabel}</small>
      </div>
  </div>
</div> 
  )
}

export default DashInComp
